/* ── Main Component ── */
const WhoThisIsForCards = ({
    section,
}) => {
    if (!section) return null;

    const { items = [] } = section;

    return (
        <div className="flex flex-col gap-5 p-4 md:px-10 lg:px-16">
            <h2 className=" ava-heading-md text-center">
                Real Results You'll Feel
            </h2>
            <div className="flex flex-wrap justify-center lg:justify-center gap-6">
                {items.map((item, index) => (
                    <div key={item.id || index}>
                        <ServiceCard item={item} />
                    </div>
                ))}
            </div>
            <div className="flex items-center justify-center">
                <button className="btn-primary" >Start Your Wellness Journey</button>
            </div>
        </div>
    );
};

export default WhoThisIsForCards;

/* ── Card Component ── */
export const ServiceCard = ({ item }) => {
    return (
        <div className="bg-white shadow-sm rounded-[10px]  flex flex-col overflow-hidden w-[260px] my-5">
            {/* Image */}
            <div className="">
                <img
                    src={item.image}
                    alt={item.label || item.title}
                    className="w-full object-cover transition-transform duration-500 h-[200px] rounded"
                />
                {/* ✅ Label ONLY if exists */}
                {/* {item.imgicon && (
          <div className="absolute top-0 left-0 flex items-center gap-2 px-3 py-3 bg-white text-white text-xs rounded-br-[10px]">
            <img src={item.imgicon} alt="" className=""  />
            <span>{item.label}</span>
          </div>
        )} */}
            </div>

            {/* Content */}
            <div className="w-full px-4 py-4 flex flex-col justify-center items-center " >
                <p
                    className="ava-text-subheading"
                    style={{color:"var(--primary-color)"}}
                >
                    {item.description}
                </p>
            </div>
        </div>
    );
};